export default {
  title: "الخوارزميات",
  pageTitle: "تفاصيل الدورة",
  parentTitle: "الدورات",
};
